import script from "./InputItem.vue?vue&type=script&setup=true&lang=js"
export * from "./InputItem.vue?vue&type=script&setup=true&lang=js"

import "./InputItem.vue?vue&type=style&index=0&id=60632b38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60632b38"]])

export default __exports__